import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const toolCountryDefinition: ResourceDefinition = {
  title: 'Tool Countries',
  nameSingular: 'Tool Country',
  namePlural: 'Tool Countries',
  className: 'Country',
  mainIdentifier: 'name',
  slug: 'countries',
  path: 'tool-countries',
  icon: 'icon-map',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (toolCountry) => ({
        type: ActionType.Link,
        link: {
          path: `${toolCountryDefinition.path}/${toolCountry.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (toolCountry) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: toolCountry,
          definition: toolCountryDefinition
        }
      })
    }
  ]
}
